module.exports = __webpack_public_path__ + "media/stylesheets/images/Atsushi Hayakawa-efc524d6df3d44677c06436e84eb4bd5.jpg";